import * as stringUtils from "@Utils/StringUtils";

/**
 * 시작일과 종료일 사이의 일수를 계산해서 반환
 */
export function calcDay(_strDte: string, _endDte: string) {
    let strDte = stringUtils.replace(_strDte, "[^0-9]", "");
    let endDte = stringUtils.replace(_endDte, "[^0-9]", "");
    if (stringUtils.isNull(strDte) || stringUtils.isNull(endDte)) {
        return "";
    }
    if (strDte.length < 8 || endDte.length < 8) {
        return "";
    }

    let fromDate = new Date(parseInt(endDte.substring(0, 4)), parseInt(endDte.substring(4, 6)) - 1, parseInt(endDte.substring(6, 8)));
    let toDate = new Date(parseInt(strDte.substring(0, 4)), parseInt(strDte.substring(4, 6)) - 1, parseInt(strDte.substring(6, 8)));

    let calc = fromDate.getTime() - toDate.getTime();

    return calc / (1000 * 60 * 60 * 24);
}

/**
 * 시작일과 종료일 사이의 달수를 계산해서 반환
 */
export function calcMonth(_strDte: string, _endDte: string) {
    let strDte = stringUtils.replace(_strDte, "[^0-9]", "");
    let endDte = stringUtils.replace(_endDte, "[^0-9]", "");

    if (stringUtils.isNull(strDte) || stringUtils.isNull(endDte)) {
        return "";
    }
    if (strDte.length < 6 || endDte.length < 6) {
        return "";
    }

    let fromMonth = parseInt(endDte.substr(0, 4), 10) * 12 + parseInt(endDte.substr(4, 2), 10);
    let toMonth = parseInt(strDte.substr(0, 4), 10) * 12 + parseInt(strDte.substr(4, 2), 10);

    return (fromMonth - toMonth);
}

/**
 * 지정한 수만큼 더해진 일자 반환
 */
export function getAddDate(_date: string, _offset: number) {
    let date = stringUtils.replace(_date, "[^0-9]", "");

    if (stringUtils.isNull(date) || stringUtils.isNull(_offset)) {
        return "";
    }

    let year = parseInt(date.toString().substr(0, 4));
    let month = parseInt(date.toString().substr(4, 2));
    let day = parseInt(date.toString().substr(6, 2)) + _offset;

    return getMakeDate(year, month, day);
}

/**
 * 년,월,일을 YYYYMMDD 형식으로 변경해서 반환
 */
export function getMakeDate(_year: number, _month: number, _date: number) {
    let objDate = new Date(_year, _month - 1, _date);
    let year = objDate.getFullYear().toString();
    let month = stringUtils.right("0" + (objDate.getMonth() + 1), 2);
    let date = stringUtils.right("0" + objDate.getDate(), 2);

    return year + month + date;
}


/**
 * 현재일자를 반환
 */
export function getToday() {
    let ObjDate = new Date();

    let today = ObjDate.getFullYear().toString();

    today += stringUtils.right("0" + (ObjDate.getMonth() + 1), 2);
    today += stringUtils.right("0" + ObjDate.getDate(), 2);

    return today;
}

export function dateFormat(value:string) {

    if(value.length === 6){
        value = "'"+value.substr(0,4) + '/' + value.substr(4,2);
    }else if(value.length === 8){
        value = "'"+value.substr(0,4) + '/' + value.substr(4,2) + '/' + value.substr(6,2);
    }

    return value;
}
/**
 * 현재 날짜를 기준으로 타입[(연('Y'), 월('M'), 일('D'), 주('W'))]에 따라 값을 증감을 하여 지정한 포멧에 맞게 날짜를 반환하는 메소드
 */
export function formatDate(_format: string, date?: Date) {
    let formatDate = "";
    let ObjDate = new Date();

    if (date) {
        ObjDate = date;
    }

    let month = '' + (ObjDate.getMonth() + 1)
    let day = '' + ObjDate.getDate()
    let year = ObjDate.getFullYear()

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    if (_format === "A") {
        formatDate = year.toString();
    } else if (_format === "M") {
        formatDate = (year + '.' + month );
    } else if (_format === "D") {
        formatDate = (year + '.' + month +"."+day);
    } else if (_format === "Q") {
        formatDate = (year + "Q" + Math.ceil(parseInt(month) / 3));
    } else if (_format === "S") {
        formatDate = (year + "S" + Math.ceil(parseInt(month) / 6));
    } else if (_format === "SM") {
        formatDate = (year + month + "S");
        if(parseInt(day) <= 15){
            formatDate+='1';
        }else{
            formatDate+='2';
        }
    }else if (_format === "yyyyMMdd") {
        formatDate = year + month + day;
    } else if(_format === 'ddHHmmss'){
        const time = ObjDate.toTimeString();
        formatDate = day + time.substring(0,8).replace(/:/g,'');
    }else {
        formatDate = getToday();
    }

    return formatDate;
}

/**
 * 해당월의 마지막 일자를 반환(DD)하는 함수,
 */
export function getLastDay(_date: string) {
    let date = stringUtils.replace(_date, "[^0-9]", "");

    if (date.length < 6) {
        return "";
    }

    let year = parseInt(date.substr(0, 4));
    let month = parseInt(date.substr(4, 2));

    if (month < 1 || month > 12) {
        return "";
    }

    let lastDay = new Date(year, month, 0);

    return lastDay.getDate();
}
/**
 * 받은 일자의 해당월 마지막 일자를 반환(YYYYMMDD)
 */
export function getLastDate(_date: string) {
    let date = stringUtils.replace(_date, "[^0-9]", "");
    if (stringUtils.isNull(date)) {
        // date가 null이면 오늘 날짜로 설정
        date = getToday();
    }

    if (date.length < 8) {
        return "";
    }
    let lastDate = getLastDay(date);

    return date.substr(0, 6) + lastDate.toString();
}

/**
 * String to Date
 */
export function stringToDate(_date: string) {
    const date = new Date();

    if(_date.length >= 4){
        date.setFullYear(parseInt(_date.substr(0,4)));
    }

    if(_date.length >= 6){

        const month = _date.substr(4,2);

        if(month.indexOf('S') !== -1){
            if (month === "S1") {
                date.setDate(5);
            } else {
                date.setDate(11);
            }
        }else if(month.indexOf('Q') !== -1){
            if (month === 'Q1') {
                date.setMonth(2);
            } else if (month === 'Q2') {
                date.setMonth(5);
            } else if (month === 'Q3') {
                date.setMonth(9);
            } else {
                date.setMonth(12);
            }
        }else{
            date.setMonth(parseInt(_date.substr(4,2))-1);
        }

    }else{
        date.setMonth(0);
    }

    if(_date.length >= 8){
        const day = _date.substr(6,2);

        if(day.indexOf('S') !== -1){
            const lastDay: any = getLastDay(_date.substr(0,6));
            if (day === "S1") {
                date.setDate(15);
            } else {
                date.setDate(lastDay);
            }
        }else{
            date.setDate(parseInt(_date.substr(6,2)));
        }
    }else{
        date.setDate(1);
    }

    date.setHours(9,0,0,0);
    return date;
}
/**
 * 지정한 수만큼 더해진 월 반환
 */
export function getAddMonth(_date: string, _offset: number) {
    let date = stringUtils.replace(_date, "[^0-9]", "");

    if (stringUtils.isNull(date) || stringUtils.isNull(_offset)) {
        return "";
    }
    if (date.length < 8) {
        return "";
    }

    let year = parseInt(date.toString().substr(0, 4));
    let month = parseInt(date.toString().substr(4, 2)) + _offset;
    let day = parseInt(date.toString().substr(6, 2));
    let lastDate, rslt;

    rslt = getMakeDate(year, month, 1);
    lastDate = getLastDay(rslt);
    rslt = rslt.substr(0, 6);

    if (day > lastDate) {
        rslt += lastDate.toString();
    } else {
        rslt += date.toString().substr(6, 2);
    }
    
    return rslt;
}

export function getQuarterly(date: Date){
	const month = date.getMonth();
	if (month <= 2) {
		return 1;
	} else if (month <= 5) {
		return 2;
	} else if (month <= 8) {
		return 3;
	} else {
		return 4;
	}
}

export function getHalfYearly(date: Date){
	const month = date.getMonth();

	if (month <= 5) {
		return 1;
	} else {
		return 2;
	}

}

export function getHalfMonthly(date: Date) {
	const day = date.getDate();

	if (day <= 15) {
		return 1;
	} else {
		return 2;
	}

}

